import { z } from 'zod'

export const contractIdSchema = z
  .string()
  .min(1)
  .max(256)
  .refine((value) => value.trim().length > 0, 'id must not be blank')

export const contractKeySchema = z
  .string()
  .min(1)
  .max(160)
  .regex(/^[a-z][a-z0-9]*(?:[._:/-][a-z0-9]+)*$/)

export const epochMsSchema = z.number().int().nonnegative()

export const usdMicrosSchema = z.number().int().nonnegative()

export const nonNegativeIntegerSchema = z.number().int().nonnegative()

export const positiveIntegerSchema = z.number().int().positive()

/** Nodes one execution outline may hold: a 10,000-chapter book with one node per chapter, its volumes and finer nodes. */
export const OUTLINE_STRUCTURE_MAX_NODES = 20_000

export const contentHashSchema = z
  .string()
  .min(8)
  .max(160)
  .regex(/^[a-z0-9]+:[A-Za-z0-9_-]+$/)

export const dataRefSchema = z.strictObject({
  kind: contractKeySchema,
  id: contractIdSchema,
  versionId: contractIdSchema.optional(),
  uri: z.string().min(1).max(1024).optional(),
  contentHash: contentHashSchema.optional()
})

export const errorSummarySchema = z.strictObject({
  errorCode: contractKeySchema,
  retryable: z.boolean(),
  message: z.string().min(1).max(500).optional()
})

export const sourceRangeSchema = z
  .strictObject({
    startOffset: nonNegativeIntegerSchema,
    endOffset: positiveIntegerSchema,
    unit: z.enum(['utf16_code_unit', 'unicode_code_point', 'byte'])
  })
  .refine((range) => range.endOffset > range.startOffset, {
    message: 'endOffset must be greater than startOffset',
    path: ['endOffset']
  })

export type ContractId = z.infer<typeof contractIdSchema>
export type ContractKey = z.infer<typeof contractKeySchema>
export type DataRef = z.infer<typeof dataRefSchema>
export type ErrorSummary = z.infer<typeof errorSummarySchema>
export type SourceRange = z.infer<typeof sourceRangeSchema>
